module.exports = __webpack_public_path__ + "img/slogan.d5591508.png";